import { Routes } from "@angular/router";
import { HomeComponent } from "./components/pages.components/home.component/home.component";
import { AboutUsComponent } from './components/pages.components/aboutus.component/aboutus.component';
import { ColleaguesComponent } from './components/pages.components/colleagues.component/colleagues.component';
import { ContactUsComponent } from './components/pages.components/contactus.component/contactus.component';
import { FAQsComponent } from './components/pages.components/faqs.component/faqs.component';
import { HardwaresComponent } from './components/pages.components/hardwares.component/hardwares.component';
import { SoftwaresComponent } from './components/pages.components/softwares.component/softwares.component';
import { WebsitesComponent } from './components/pages.components/websites.component/websites.component';
import { ProductsComponent } from './components/pages.components/products.component/products.component';
import { ArticlesComponent } from './components/contents.components/articles.component/articles.component';
import { BlogsComponent } from './components/contents.components/blogs.component/blogs.component';
import { VideosComponent } from './components/contents.components/videos.component/videos.component';
import { ArticleDetailsComponent } from './components/contents.components/articledetails.component/articledetails.component';
import { BlogDetailsComponent } from './components/contents.components/blogdetails.component/blogdetails.component';
import { VideoDetailsComponent } from './components/contents.components/videodetails.component/videodetails.component';
import { ProductDetailsComponent } from './components/pages.components/productdetails.component/productdetails.component';
import { GalleryComponent } from './components/pages.components/gallery.component/gallery.component';
import { DynamicPageComponent } from './components/pages.components/dynamicpage.component/dynamicpage.component';
import { RepairRequestComponent } from "./components/common.components/repair-request.component/repair-request.component";
import { PaybackComponent } from "./components/common.components/payback/payback.component";
//import { PermitsComponent } from "./components/contents.components/permits.component/permits.component";
import { PermitssoftComponent } from "./components/contents.components/permitssoft.component/permitssoft.component";
import { PermitshardComponent } from "./components/contents.components/permitshard.component/permitshard.component";
import { PermitDetailsComponent } from "./components/contents.components/permitdetails.component/permitdetails.component";
export const appRoutes: Routes = [
    { path: "", component: HomeComponent },
    { path: 'aboutus', component: AboutUsComponent },
    { path: 'colleagues', component: ColleaguesComponent },
    { path: 'contactus', component: ContactUsComponent },
    { path: 'faqs', component: FAQsComponent },
    { path: 'hardwares/:pageNumber', component: HardwaresComponent },
    { path: 'softwares/:pageNumber', component: SoftwaresComponent },
    { path: 'websites/:pageNumber', component: WebsitesComponent },
    { path: 'products/:pageNumber', component: ProductsComponent },
    { path: 'articles/:pageNumber', component: ArticlesComponent },
    { path: 'articledetails/:id', component: ArticleDetailsComponent },
    { path: 'blogs/:pageNumber', component: BlogsComponent },
    { path: 'blogdetails/:id', component: BlogDetailsComponent },
    { path: 'videos/:pageNumber', component: VideosComponent },
    { path: 'videodetails/:id', component: VideoDetailsComponent },
    { path: 'productdetails/:id', component: ProductDetailsComponent },
    { path: 'gallery/:id', component: GalleryComponent },
    { path: 'page/:id', component: DynamicPageComponent },
    { path: 'repair-request', component: RepairRequestComponent },
    { path: 'permitssoft', component: PermitssoftComponent },
    { path: 'permitshard', component: PermitshardComponent },
    { path: 'permitdetails/:id', component: PermitDetailsComponent },

    

    { path: 'payback', component: PaybackComponent }
];
